export default "__VITE_ASSET__D7c780dE__"